// TemplateFactory.ts
import { BannerTemplate } from "./BannerTemplate";
import { ModalTemplate } from "./ModalTemplate";
import { InlineTemplate } from "./InlineTemplate";
import { SmallInfoBoxTemplate } from "./SmallInfoboxTemplate";
export class TemplateFactory {
    static create(templateType, action) {
        switch (templateType) {
            case "modal":
                return new ModalTemplate(action);
            case "inline":
                return new InlineTemplate(action);
            case "info-box":
                return new SmallInfoBoxTemplate(action);
            case "banner":
            default:
                return new BannerTemplate(action);
        }
    }
}
